import { defineStore } from 'pinia'

import type { BookingStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useBookingStore = defineStore('booking', {
  state: (): BookingStore => ({
    loading: false,
    loadingDone: false,
    loadingFinished: false,
    loadingFinishedDone: false,
    bookingsMath: null,
    bookingsEla: null,
    currentBookingMath: null,
    currentBookingEla: null,
    finishedBookingsMath: null,
    finishedBookingsEla: null,
    countdown: null,
    modalJoinDemoLesson: false,
    modalJoinPaidLesson: false,
    bookingTrigger: 0,
    icsLink: null,
    icsProcessing: false,
  }),
  actions,
  getters,
})
